import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fetchCompetitionParameters } from './fetch-competition-parameters';
import { submitFeedbackParameterEpic } from './submit-feedback';

export const missedDealFeedbackEpic = () => {
  return combineEpics(
    withAppCrashIfException('fetchCompetitionParameter', fetchCompetitionParameters()),
    withAppCrashIfException('submitFeedbackParameter', submitFeedbackParameterEpic()),
  );
};
